import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminChangelogRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.'

  changelog(modelId: number, modelType: string) {
    return this.ziggyRoute('changes_logs', { model_id: modelId, model_type: modelType })
  }
}
